
/**
 * Enum que representa los tipos de prueba de vida para el proceso de verificación de identidad.
 */
export enum TipoPruebaVidaEnum
{
    /** 
    *Registro de usuario - envio de correo para verificar la correo electrónico y validar la biometría usuario
    */
    REGISTRO_USUARIO = 1,
    /**
    * Cambio de correo electrónico - envio de correo para verificar el nuevo correo y validar al usuario mediante biometría
    */
    CAMBIO_CORREO = 2,
    /**
    * Recuperación de contraseña
    */
    // RECUPERACION_CONTRASENA = 3
}